module.exports = __webpack_public_path__ + "media/images/image_5-18a458852e5c35d04f99a3bfd2748484.jpg";